import { Facade } from "@/modules/budget/monitoring/input-forms/types/roots/Facade";
import { FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm";
import { App23FilterSettingsForm } from "./App23FilterSettingsForm";

export class App23InputFormFacade implements Facade {
    getFilterSettings(): FilterSettingsForm {
        const form: App23FilterSettingsForm = {
            user_id: "",
            edit_access: true,
            delete_access: false,
            convert: 1000,
            application: null,
        }
        return form
    }
}
